import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import { CourseAlertsModel, ICourseAlerts } from '../models/course_alerts_model';

export type SaveCourseAlertsCommand = (courseAlerts: ICourseAlerts) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'saveCourseAlertsCommand',
    (ngCourseAlertsModel: CourseAlertsModel, defineCommandORM: IDefineCommand): ICommand => {
      return defineCommandORM('saveCourseAlertsCommand', (deferred, courseAlerts: ICourseAlerts) => {
        ngCourseAlertsModel.clear().write(courseAlerts);
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/course_alerts/commands/save_course_alerts_command.ts